/** Values baked into the bundle at `docker compose build` / `npm run build` (see `VITE_*` in env.d.ts). */
export function viteRelease(): string {
  return String(import.meta.env.VITE_RELEASE ?? '').trim();
}

export function viteBuildTime(): string {
  return String(import.meta.env.VITE_BUILD_TIME ?? '').trim();
}

export function viteGitSha(): string {
  return String(import.meta.env.VITE_GIT_SHA ?? '').trim();
}

export function hasAnyBuildMetadata(): boolean {
  return Boolean(viteRelease() || viteBuildTime() || viteGitSha());
}
